module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA24AAAA0CAYAAADyrGtrAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gUTDjUd1r3kTQAAAR1JREFUeNrt1zENACAQBEHA0vl3cKLwQPJUMxK2251kATCvrQgAwJMjAQAAgHEDAADAuAEAABg3AAAAjBsAAADGDQAAwLgBAABg3AAAAIwbAAAAxg0AAADjBgAAYNwAAAAwbgAAABg3AAAA4wYAAIBxAwAAMG4AAAAYNwAAAIwbAACAcQMAAMC4AQAAGDcAAACMGwAAAMYNAADAuAEAAGDcAAAAMG4AAADGDQAAAOMGAABg3AAAADBuAAAAGDcAAADjBgAAgHEDAAAwbgAAABg3AAAAjBsAAIBxAwAAwLgBAABg3AAAAIwbAAAAxg0AAMC4AQAAYNwAAAAwbgAAAMYNAAAA4wYAAGDcAAAAMG4AAAAYNwAAAOMGAADAXxeaAwNl157VYgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/band-ad-header.png
// module id = 203
// module chunks = 0